export default {
  transaction: Object,
}
